import { render, staticRenderFns } from "./subSymptom.vue?vue&type=template&id=72a3fb28&"
import script from "./subSymptom.vue?vue&type=script&lang=ts&"
export * from "./subSymptom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports